import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  TRY_LOGIN,
  TRY_LOGIN_SUCCESS,
  TRY_LOGIN_FAILED,
  LOGOUT,
  LOGOUT_SUCCESS,
  SET_EXPIRANDO,
  RENOVAR_TOKEN,
  RENOVAR_TOKEN_SUCCESS,
  RENOVAR_TOKEN_FAILED,
  SET_PERMISOCC,
} from '../types';

const initialState = {
  usuario: null,
  token: null,
  error: null,
  expirando: false,
  loading: false,
  openAlertDialogSlideLogin: true,
  permisoCC: true,
  esencialCC: false,
  reestriccionCC: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
    case TRY_LOGIN: {
      return {
        ...state,
        token: null,
        error: null,
        loading: true,
      };
    }
    case TRY_LOGIN_SUCCESS:
    case RENOVAR_TOKEN_SUCCESS:
    case LOGIN_SUCCESS: {
      return {
        ...state,
        usuario: action.payload.usuario,
        token: action.payload.token,
        loading: false,
        expirando: false,
        openAlertDialogSlideLogin: false,
      };
    }
    case TRY_LOGIN_FAILED: {
      return {
        ...state,
        usuario: null,
        token: null,
        error: null,
        expirando: false,
        loading: false,
      };
    }
    case LOGIN_ERROR: {
      return {
        ...state,
        usuario: null,
        token: null,
        error: action.payload,
        expirando: false,
        loading: false,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        expirando: false,
      };
    }
    case SET_EXPIRANDO: {
      return {
        ...state,
        expirando: true,
      };
    }
    case RENOVAR_TOKEN: {
      return {
        ...state,
      };
    }
    case RENOVAR_TOKEN_FAILED: {
      return {
        ...state,
      };
    }
    case SET_PERMISOCC: {
      return {
        ...state,
        permisoCC: action.payload.habilitado,
        esencialCC: action.payload.esencial,
        reestriccionCC: action.payload.reestriccion,
      };
    }
    case LOGOUT_SUCCESS: {
      return initialState;
    }
    default:
      return state;
  }
};
